export const GET_ADMINS = 'GET_ADMINS';
export const SET_ADMINS = 'SET_ADMINS';
export const API_ERROR = 'LOGIN_API_ERROR';
export const SET_ADMIN = 'SET_ADMIN';
export const ADD_ADMIN = 'ADD_ADMIN';
export const EMPTY_ADMIN = 'EMPTY_ADMIN';
export const DELETE_ADMIN = 'DELETE_ADMIN';
export const EDIT_ADMIN = 'EDIT_ADMIN';
export const UPDATE_ADMIN = 'UPDATE_ADMIN';
export const SET_ADMIN_FILTER = 'SET_ADMIN_FILTER';